import { IPE_WORKBENCH_PATH } from '@/config/ipeRoutes';
import {
  buildWorkbenchNavUrl,
  navigateWorkbenchWithState,
  normalizeWorkbenchNavId,
} from '@/pages/ipe/workbench/constants/workbenchNavConfig';

/**
 * 解析公告步骤的引导定位地址（用于登录指引，而非弹窗内跳转按钮）。
 * 支持：
 * - /ipe?activeNav=workflowHub
 * - http(s)://同域/ipe?activeNav=workflowHub
 * - 兼容 /pa?activeNav=…
 */
export function resolveSystemAnnouncementGuideTarget(rawUrl) {
  const raw = String(rawUrl || '').trim();
  if (!raw) return null;

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const absolute = /^https?:\/\//i.test(raw);
    const url = absolute ? new URL(raw) : new URL(raw, base);

    if (absolute && typeof window !== 'undefined' && url.origin !== window.location.origin) {
      return { kind: 'external', href: url.toString() };
    }

    let pathname = url.pathname || IPE_WORKBENCH_PATH;
    if (pathname === '/pa' || pathname.startsWith('/pa/')) {
      pathname = pathname.replace(/^\/pa/, IPE_WORKBENCH_PATH) || IPE_WORKBENCH_PATH;
    }
    if (!pathname || pathname === '/') {
      pathname = IPE_WORKBENCH_PATH;
    }

    const activeNavRaw = url.searchParams.get('activeNav');
    const activeNav = activeNavRaw ? normalizeWorkbenchNavId(activeNavRaw) : '';
    if (activeNav) {
      return {
        kind: 'workbench',
        activeNav,
        to: buildWorkbenchNavUrl(activeNav),
      };
    }

    return {
      kind: 'path',
      to: `${pathname}${url.search || ''}`,
    };
  } catch {
    if (raw.startsWith('/')) {
      return { kind: 'path', to: raw };
    }
    return null;
  }
}

/**
 * 按步骤引导地址定位工作台页面（同域）。
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {string} rawUrl
 */
export function locateSystemAnnouncementGuide(navigate, rawUrl) {
  const target = resolveSystemAnnouncementGuideTarget(rawUrl);
  if (!target) return false;

  if (target.kind === 'workbench') {
    navigateWorkbenchWithState(navigate, target.activeNav, {}, { replace: true });
    return true;
  }

  if (target.kind === 'path' && typeof navigate === 'function') {
    navigate(target.to, { replace: true });
    return true;
  }

  // 外链不在指引流程中强跳，避免打断工作台
  return false;
}
